import React, { useState } from "react";
import { Sparkles, Check, Lightbulb, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const AiPolish = ({ enabled = true, text, kind, title, onApply, onApplyShort }) => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  if (!enabled) return null;

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/ai/polish", { text, kind, title });
      setResult(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "AI couldn't polish that just now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-2">
      <button type="button" onClick={run} disabled={busy || !text || text.length < 20} data-testid="ai-polish-btn"
        className="inline-flex items-center gap-1.5 text-xs font-bold text-[color:var(--coral)] hover:underline disabled:opacity-40 disabled:no-underline">
        <Sparkles size={13} className={busy ? "animate-pulse" : ""} /> {busy ? "Polishing…" : "Polish with AI & get suggestions"}
      </button>
      {result && (
        <div data-testid="ai-polish-result" className="mt-3 rounded-2xl border border-[color:var(--coral)]/30 bg-[color:var(--coral)]/5 p-4 space-y-3 text-sm">
          <div className="flex items-start justify-between gap-2">
            <div className="text-[0.68rem] uppercase tracking-[0.14em] font-bold text-[color:var(--coral)]">AI-polished version</div>
            <button type="button" onClick={() => setResult(null)} className="p-1 rounded-full hover:bg-white" data-testid="ai-polish-close"><X size={13} /></button>
          </div>
          <p className="leading-relaxed text-[color:var(--ink)]" data-testid="ai-polished-text">{result.polished}</p>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => { onApply(result.polished); toast.success("Description updated."); }} data-testid="ai-polish-apply" className="btn-pill btn-primary text-xs py-1.5 px-3"><Check size={12} /> Use this</button>
            {result.short_description && onApplyShort && (
              <button type="button" onClick={() => { onApplyShort(result.short_description); toast.success("Short blurb updated."); }} data-testid="ai-polish-apply-short" className="btn-pill btn-outline text-xs py-1.5 px-3">Use as short blurb</button>
            )}
          </div>
          {result.suggestions?.length > 0 && (
            <div>
              <div className="text-[0.68rem] uppercase tracking-[0.14em] font-bold text-[color:var(--ink-2)] mb-1.5 inline-flex items-center gap-1"><Lightbulb size={12} /> Suggestions</div>
              <ul className="space-y-1 list-disc pl-4 text-[color:var(--ink-2)]">
                {result.suggestions.map((s, i) => <li key={i} data-testid={`ai-suggestion-${i}`}>{s}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
